module.exports = __webpack_public_path__ + "static/media/staffi-business-lines.e754738a.png";